<div class="sidebar" [ngClass]="{'collapsed': isCollapsed}">
  <div class="container" [ngClass]="{'collapsed': isCollapsed}">
      <div class="home menu-item" [ngClass]="{'active': activeHome, 'collapsed': isCollapsed}" (click)="navigate('/home')">
              <mat-icon>home</mat-icon>
              <a *ngIf="!isCollapsed">Packing List Tracker</a>
      </div>

      <div class="archive menu-item" [ngClass]="{'active': activeArchived, 'collapsed': isCollapsed}" (click)="navigate('/archived')">
          <mat-icon>inventory_2</mat-icon>
          <a *ngIf="!isCollapsed">Archived Entries</a>
      </div>

      <div class="notifications  menu-item"  [ngClass]="{'collapsed': isCollapsed}" (click)="notificationsActive()" (keydown.enter)="notificationsActive()">
          <mat-icon matBadge="2" matBadgePosition="after" matBadgeSize="large">notifications</mat-icon>
          <!--<mat-icon *ngIf="notifications">notifications_active</mat-icon>-->
          <a *ngIf="!isCollapsed">Notifications</a>
      </div>

      <div class="support  menu-item"  [ngClass]="{'collapsed': isCollapsed}">
          <mat-icon>help</mat-icon>
          <a *ngIf="!isCollapsed"  href="{{'mailto:ECSSEGDLSupport@astrazeneca.com?subject=Tolling Packing List Tracker Support&body=Please explain your issue here.'}}"
            style="color: white;">Support</a>
      </div>

      <div class="bottom-sidebar" [ngClass]="{'collapsed': isCollapsed}">
          <div class="collapse  menu-item" (click)="toggleCollapse()" (keydown.enter)="toggleCollapse()" [ngClass]="{'collapsed': isCollapsed}">
              <img *ngIf="!isCollapsed" class="icon-collapse" src="assets/collapse.svg" alt="collapse-icon">
              <img *ngIf="isCollapsed" class="icon-collapse" src="assets/expand.svg" alt="expand-icon">
              <a *ngIf="!isCollapsed">Collapse</a>
          </div>

          <div class="az-logo" [ngClass]="{'collapsed': isCollapsed}">
              <img class="logo" *ngIf="!isCollapsed" src="assets/logo.svg" alt="az-logo">
              <img class="logo" *ngIf="isCollapsed" src="assets/small-logo.svg" alt="az-logo">
          </div>
      </div>
  </div>
</div>